import React, { useState } from "react";
import DateSvg from "../../assets/svg/DateSvg";
import TimeSvg from "../../assets/svg/TimeSvg";
import MainButton from "../btns/MainButton";
import FilmCardPrePopup from "./FilmCardPrePopup";

const FilmCard = ({
  img,
  title,
  time,
  date,
  centers,
  color,
  flags,
  pufik_lang,
  iticket_link,
  variant = "default",
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const isCompact = variant === "compact";

  const hasTicketLink = iticket_link && iticket_link.trim() !== "";

  const handleButtonClick = () => {
    if (hasTicketLink) {
      window.open(iticket_link, "_blank", "noopener,noreferrer");
    } else {
      setIsPopupOpen(true);
    }
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const popup = isPopupOpen && !hasTicketLink && (
    <FilmCardPrePopup
      closePopup={closePopup}
      img={img}
      title={title}
      time={time}
      date={date}
      centers={centers}
      flags={flags}
      pufik_lang={pufik_lang}
    />
  );

  const posterStyle = { backgroundImage: `url(${img})` };
  const posterBase = "bg-center bg-cover bg-no-repeat";
  const iconSize = isCompact ? 22 : 20;
  const metaTextClass = isCompact
    ? "text-[15px] sm:text-base font-medium"
    : "text-sm sm:text-[15px] font-medium";
  const flagSizeClass = isCompact ? "w-[24px] h-[24px]" : "w-[22px] h-[22px]";
  const buttonClass = isCompact
    ? "text-[15px] sm:text-base font-semibold py-1.5 px-5"
    : "text-sm sm:text-[15px] font-semibold py-1.5 px-5";

  const metaRow = (
    <div className="flex flex-wrap gap-x-4 gap-y-1.5 justify-center sm:justify-start">
      <div className="flex gap-2 items-center">
        <TimeSvg width={iconSize} height={iconSize} />
        <p className={`text-white ${metaTextClass} transition ease-in-out duration-300 group-hover:text-purple`}>{time}</p>
      </div>
      <div className="flex gap-2 items-center">
        <DateSvg width={iconSize} height={iconSize} />
        <p className={`text-white ${metaTextClass} transition ease-in-out duration-300 group-hover:text-purple`}>{date}</p>
      </div>
    </div>
  );

  const flagsRow = flags?.length > 0 && (
    <div className="flex gap-2.5 flex-wrap justify-center sm:justify-start">
      {flags.map((flag, index) => (
        <img key={index} className={`${flagSizeClass} rounded-full`} src={flag} alt="flag" />
      ))}
    </div>
  );

  const ticketButton = (
    <div className="flex justify-center sm:justify-start">
      <MainButton
        title={hasTicketLink ? "Bilet al →" : "Bilet al"}
        onClick={handleButtonClick}
        className={buttonClass}
      />
    </div>
  );

  if (isCompact) {
    return (
      <div
        className={`group flex gap-4 rounded-[12px] border border-${color} border-[2px] p-4 hover:bg-white transition ease-in-out duration-300 overflow-hidden`}
      >
        <div
          style={posterStyle}
          className={`${posterBase} w-[104px] sm:w-[118px] shrink-0 aspect-[2/3] rounded-[10px]`}
        />
        <div className="flex flex-col gap-2.5 flex-1 min-w-0 justify-between py-1">
          <p className="text-white text-[18px] sm:text-[20px] font-bold leading-snug line-clamp-2 transition ease-in-out duration-300 group-hover:text-purple">
            {title}
          </p>
          {metaRow}
          {flagsRow}
          {ticketButton}
        </div>
        {popup}
      </div>
    );
  }

  return (
    <div
      className={`group rounded-[12px] border border-${color} border-[2px] hover:bg-white hover:text-purple transition ease-in-out duration-300 overflow-hidden h-full flex flex-col`}
    >
      <div
        style={posterStyle}
        className={`${posterBase} w-full aspect-[2/3] shrink-0`}
      />

      <div className={`w-full bg-${color} h-[2px]`} />

      <div className="p-3.5 flex flex-col gap-2.5 items-center flex-1">
        <p className="text-white text-center text-[19px] sm:text-[21px] font-bold leading-snug line-clamp-2 transition ease-in-out duration-300 group-hover:text-purple">
          {title}
        </p>

        {metaRow}

        {flagsRow}

        <div className="mt-auto pt-1 flex justify-center">
          <MainButton
            title={hasTicketLink ? "Bilet al →" : "Bilet al"}
            onClick={handleButtonClick}
            className={buttonClass}
          />
        </div>
      </div>

      {popup}
    </div>
  );
};

export default FilmCard;
